'use strict';

var $           = require('jquery');
var _           = require('underscore');
var Backbone    = require('backbone');
var router      = require('./router'); // eslint-disable-line no-unused-vars
import hamburgerSections from './client/common/hamburger-sections';
import abNav from './client/common/randomize-ab-nav';
// import navBarSearch from './client/common/navbar-search';
import hamburger from './client/common/hamburger';
// import navHomepage from './client/common/navbar-homepage';

abNav();
// navBarSearch.on();
hamburgerSections();
hamburger.on();
// navHomepage.on();
window.$ = window.jQuery = $;
require('../public/bower_components/foundation/js/foundation/foundation.js');
require('../public/bower_components/foundation/js/foundation/foundation.reveal.js');
Backbone.$ = $;
Backbone._ = _;

// Load all the router events
require('./../config/compiled/router-events');

var admanager = require('./client/common/admanager');


// Build the social links
var postShareButtons = require('./client/common/share-buttons');
postShareButtons.on();

// Lazy load
require('../node_modules/lazyloadxt/dist/jquery.lazyloadxt');
require('../node_modules/lazyloadxt/dist/jquery.lazyloadxt.video');
require('../node_modules/lazyloadxt/dist/jquery.lazyloadxt.srcset');

admanager();

// Globals need to happen before document ready
var startApp = function () {

    $.extend($.lazyLoadXT, {
        edgeY: 200,
        edgeX: 400,
        scrollContainer: 'body'
    });

    $(function () {
        Backbone.history.start({
            root: '/',
            pushState: true,
            silent: false
        });
    });
};

startApp();
